import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class MatDialogSizeService {
    constructor() {}

    wX: string =
        window.innerWidth <= 480
            ? "100%"
            : window.innerWidth <= 768
              ? "100%"
              : window.innerWidth <= 992
                ? "100%"
                : "100%";
    wIX: string =
        window.innerWidth <= 576 ? "95%" : window.innerWidth <= 820 ? "95%" : window.innerWidth <= 992 ? "90%" : "90%";
    wVIII: string =
        window.innerWidth <= 576 ? "95%" : window.innerWidth <= 820 ? "95%" : window.innerWidth <= 992 ? "90%" : "80%";

    wVII: string =
        window.innerWidth <= 576 ? "95%" : window.innerWidth <= 820 ? "95%" : window.innerWidth <= 992 ? "80%" : "70%";

    wVI: string =
        window.innerWidth <= 576 ? "95%" : window.innerWidth <= 820 ? "90%" : window.innerWidth <= 992 ? "70%" : "60%";

    wV: string =
        window.innerWidth <= 576 ? "95%" : window.innerWidth <= 820 ? "80%" : window.innerWidth <= 992 ? "60%" : "50%";

    wIV: string =
        window.innerWidth <= 576 ? "90%" : window.innerWidth <= 820 ? "70%" : window.innerWidth <= 992 ? "50%" : "40%";

    wIIIS: string =
        window.innerWidth <= 576 ? "90%" : window.innerWidth <= 820 ? "65%" : window.innerWidth <= 992 ? "45%" : "35%";
    wIII: string =
        window.innerWidth <= 576 ? "95%" : window.innerWidth <= 820 ? "60%" : window.innerWidth <= 992 ? "40%" : "30%";

    wIIS: string =
        window.innerWidth <= 576 ? "90%" : window.innerWidth <= 820 ? "55%" : window.innerWidth <= 992 ? "30%" : "25%";

    wII: string =
        window.innerWidth <= 576 ? "90%" : window.innerWidth <= 820 ? "50%" : window.innerWidth <= 992 ? "20%" : "20%";

    wI: string =
        window.innerWidth <= 576 ? "90%" : window.innerWidth <= 820 ? "40%" : window.innerWidth <= 992 ? "20%" : "10%";
}
